export default __webpack_public_path__ + "assets/icon-checkbook.433ce8cd.webp";